/**
 * Live stage assets, relative to the host's stageAssetBaseUrl.
 *
 * The only binary source of truth is frontend-provision/src/static. SDK and
 * reference builds copy these files, never a separately maintained asset set.
 * Keep this module browser-safe: the Node copy/serve helper also imports it.
 */
export const PRODUCT_VIEWER_ASSET_MANIFEST = Object.freeze({
  environment: Object.freeze({
    path: "hdri/brown_photostudio_02_1k.hdr",
    contentType: "image/vnd.radiance",
  }),
  floorMap: Object.freeze({
    path: "textures/floor/beige_wall_001_diff_1k.jpg",
    contentType: "image/jpeg",
  }),
  floorNormalMap: Object.freeze({
    path: "textures/floor/beige_wall_001_nor_gl_1k.jpg",
    contentType: "image/jpeg",
  }),
  floorArmMap: Object.freeze({
    path: "textures/floor/beige_wall_001_arm_1k.jpg",
    contentType: "image/jpeg",
  }),
});
